// extracted by mini-css-extract-plugin
module.exports = {"item_title":"DocGrid_item_title__CvoHY","item_description":"DocGrid_item_description__YTGom","item_titleLink":"DocGrid_item_titleLink__sR8GH"};